import React from 'react';
import heroImage from '../../../../assets/images/technology/hero/hero.jpg';
import './Hero.css';

const Hero = () => {
  return (
    <section className="technology-hero">
      <img
        className="technology-hero__bg"
        src={heroImage}
        alt=""
        aria-hidden="true"
      />
      <div className="technology-hero__overlay" />

      <div className="technology-hero__inner">
        <div className="technology-hero__content">
          <p className="technology-hero__eyebrow">Technology</p>
          <h1 className="technology-hero__title">
            Built for Stability.
            <br />
            Designed for Access.
          </h1>
          <p className="technology-hero__text">
            Our technology ecosystem provides the secure, consistent, and
            high-performance infrastructure required to support your financial
            objectives across global markets.
          </p>
        </div>
      </div>
    </section>
  );
};

export default Hero;
